import { gql, useFragment } from '@apollo/client'

/**
 * Hook for checking if a product is favorite using Apollo Cache only
 * @param productId - The ID of the product
 * @returns True if the product is favorite, false otherwise
 */
export const useIsFavorite = (productId: string) => {
  const { data } = useFragment({
    fragment: gql`
      fragment ProductIsFavorite on Product {
        isFavorite
      }
    `,
    from: { id: productId, __typename: 'Product' },
  })

  return data?.isFavorite ?? false
}